<template>
  <el-card shadow="never">
    <el-row style="margin-bottom: 22px">
      <el-input v-model="queryInfo.materialCode" class="input" placeholder="备件编码" clearable></el-input>
      <el-button type="primary" @click="currentChange(1)" :loading="loading">查询</el-button>
      <el-button type="primary" @click="dialogVisible = true">添加</el-button>
    </el-row>

    <el-table :data="dataList" border style="width: 100%" stripe>
      <el-table-column align="center" prop="materialCode" label="备件编码"></el-table-column>
      <el-table-column align="center" prop="materialCodeAfter" label="校色后备件编码"></el-table-column>
      <el-table-column align="center" prop="newLabel" label="是否新版标签" :formatter="isFormatter"></el-table-column>
      <el-table-column align="center" prop="createUserName" label="创建人"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button @click="deleteRule(scope.row)" type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination background layout="total,prev, pager, next" :page-size="pageSize" :total="total" @current-change="currentChange" :current-page.sync="queryInfo.pageNo"></el-pagination>
    </div>
    <el-dialog title="添加PN关系" :visible.sync="dialogVisible" :close-on-click-modal="false" width="700px" :before-close="handleClose">
      <el-form v-model="formData" label-width="200px">
        <el-form-item label="备件编码：">
          <el-input v-model.trim="formData.materialCode" placeholder="请输入备件编码" style="width: 350px" clearable></el-input>
        </el-form-item>
        <el-form-item label="校色后备件编码：">
          <el-input v-model.trim="formData.materialCodeAfter" placeholder="请输入校色后备件编码" style="width: 350px" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否新版标签：">
          <el-switch style="margin-right: 10px" v-model="formData.newLabel"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="addRule">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  name: "ColorCalibrationPn",
  data() {
    return {
      queryInfo: {
        materialCode: '',
        pageNo: 1
      },
      formData: {
        materialCode: '',
        materialCodeAfter: '',
        newLabel: false
      },
      dataList: [],
      total: 0,
      pageSize: 0,
      dialogVisible: false,
      loading: false
    }
  },
  created() {
    this.search();
  },
  methods: {
    async search() {
      this.loading = true;
      const {data: res} = await this.$axios.post('colorCalibrationPn/queryList', this.queryInfo);
      this.loading = false;
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.dataList = res.data.records;
      this.total = res.data.total;
      this.pageSize = res.data.size;
    },
    currentChange(pageNo) {
      this.queryInfo.pageNo = pageNo;
      this.search()
    },
    deleteRule(row) {
      this.$confirm('确定删除吗？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        this.$axios.post('colorCalibrationPn/delete', row.materialCode).then(response => {
          if (response.data.code !== 0) {
            return this.$message.error(response.data.message);
          }
          this.$message.success("删除成功");
          this.search();
        })
      })
    },
    async addRule() {
      if (!this.formData.materialCode) {
        return this.$message.error('备件编码不能为空');
      }
      if (!this.formData.materialCodeAfter) {
        return this.$message.error('校色后备件编码不能为空');
      }

      const {data: res} = await this.$axios.post('colorCalibrationPn/add', this.formData);
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.$message.success("添加成功");
      this.search();
      this.handleClose()
      this.formData.materialCode = ''
      this.formData.materialCodeAfter = ''
      this.formData.newLabel = false
    },
    handleClose() {
      this.dialogVisible = false;
    },
    isFormatter(row, column, cellValue) {
      if (cellValue == true) {
        return '是';
      }
      if (cellValue == false) {
        return '否';
      }
      if (cellValue == null || cellValue == '') {
        return '';
      }
    },
  }
}
</script>

<style scoped>
.input {
  width: 300px;
  margin-right: 10px;
}
</style>